import { render } from "./SubscriptionChangeAmountModal.vue?vue&type=template&id=1179cf9b"
import script from "./SubscriptionChangeAmountModal.vue?vue&type=script&lang=js"
export * from "./SubscriptionChangeAmountModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__